import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white p-4 rounded-lg mt-4 text-textPrimary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-md font-bold text-left mb-4" }, "Valor acordado", -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-y-4 gap-x-4 text-textPrimary" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Valor por hora", -1)
const _hoisted_6 = { class: "mt-1 text-sm" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Valor original do plantão", -1)
const _hoisted_9 = { class: "mt-1 text-sm" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Custo base", -1)
const _hoisted_12 = { class: "mt-1 text-sm" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Custo excepcional", -1)
const _hoisted_15 = { class: "mt-1 text-sm" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Prejuízo Previsto", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-left",
  "data-testid": "exception-agreed-value-total-requested"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-bold" }, "Valor total solicitado", -1)
const _hoisted_20 = { class: "mt-1 text-sm font-bold" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionAgreedValueCard',
  props: {
    originalHourlyValue: {},
    exceptionalCost: {},
    baseCost: {},
    estimatedLossTotal: {},
    baseDuration: {},
    exceptionalDuration: {},
    totalExceptionalValue: {}
  },
  setup(__props: any) {

const props = __props;


const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString(formatCurrency(props.originalHourlyValue)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString(formatCurrency(props.originalHourlyValue * props.baseDuration)), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(props.baseCost === null ? '—' : formatCurrency(props.baseCost)), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, _toDisplayString(props.exceptionalCost === null ? '—' : formatCurrency(props.exceptionalCost)), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("p", {
          class: _normalizeClass(["mt-1 text-sm", 'text-negative'])
        }, _toDisplayString(props.estimatedLossTotal === null ? '—' : formatCurrency(props.estimatedLossTotal)), 1)
      ]),
      (props.totalExceptionalValue !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("p", _hoisted_20, _toDisplayString(props.totalExceptionalValue === null ? '—' : formatCurrency(props.totalExceptionalValue)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})